
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { CalendarTokenDto_$reflection, CalendarEntryDto_$reflection } from "../Shared/Calendar.js";
import { union_type, unit_type, class_type, record_type, option_type, list_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, RequestedValue$1_$reflection } from "../Shared/Shared.js";

export class State extends Record {
    constructor(CalendarData, CalendarToken, FormState) {
        super();
        this.CalendarData = CalendarData;
        this.CalendarToken = CalendarToken;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Calendar.Types.State", [], State, () => [["CalendarData", RequestedValue$1_$reflection(list_type(CalendarEntryDto_$reflection()))], ["CalendarToken", RequestedValue$1_$reflection(option_type(CalendarTokenDto_$reflection()))], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CalendarDataFetched", "FetchError", "FetchCalendarToken", "CalendarTokenFetched", "CalendarTokenFetchError", "CreateToken", "TokenCreated", "TokenCreateError", "RegenerateToken", "CalendarTokenRegenerated", "CalendarTokenRegenerateError", "DeleteToken", "TokenDeleted", "TokenDeleteError"];
    }
}

export function Msg_$reflection() {
    return union_type("Calendar.Types.Msg", [], Msg, () => [[["Item", list_type(CalendarEntryDto_$reflection())]], [["Item", class_type("System.Exception")]], [], [["Item", option_type(CalendarTokenDto_$reflection())]], [["Item", class_type("System.Exception")]], [], [["Item", ClientApiResponse$1_$reflection(option_type(CalendarTokenDto_$reflection()))]], [["Item", class_type("System.Exception")]], [], [["Item", ClientApiResponse$1_$reflection(option_type(CalendarTokenDto_$reflection()))]], [["Item", class_type("System.Exception")]], [], [["Item", ClientApiResponse$1_$reflection(unit_type)]], [["Item", class_type("System.Exception")]]]);
}

